import React from 'react';

// Material-UI
import { Tooltip } from '@mui/material';

export default function CustomTooltip(props) {
    const { color, message, placement } = props;
    const tooltipStyles = getTooltipStyles(color);

    return (
        <Tooltip
            arrow
            disableFocusListener
            placement={placement || 'top'}
            enterTouchDelay={0}
            leaveTouchDelay={5000}
            title={message || ''}
            componentsProps={{
                tooltip: {
                    sx: tooltipStyles.tooltip,
                },
                arrow: {
                    sx: tooltipStyles.arrow,
                },
            }}
        >
            {props.children}
        </Tooltip>
    );
}

function getTooltipStyles(color) {
    switch (color) {
        case 'grey':
            return {
                tooltip: {
                    fontSize: '1rem',
                },
                arrow: {
                    color: 'secondary.main',
                },
            };
        case 'green':
            return {
                tooltip: {
                    backgroundColor: 'success.main',
                    fontSize: '1rem',
                },
                arrow: {
                    color: 'success.main',
                },
            };
        case 'yellow':
            return {
                tooltip: {
                    backgroundColor: '#fcd32d',
                    fontSize: '1rem',
                },
                arrow: {
                    color: '#fcd32d',
                },
            };
        case 'orange':
            return {
                tooltip: {
                    backgroundColor: 'warning.main',
                    fontSize: '1rem',
                },
                arrow: {
                    color: 'warning.main',
                },
            };
        case 'red':
            return {
                tooltip: {
                    backgroundColor: 'error.main',
                    fontSize: '1rem',
                },
                arrow: {
                    color: 'error.main',
                },
            };
        default:
            return {
                tooltip: {
                    backgroundColor: 'secondary.main',
                    fontSize: '1rem',
                },
                arrow: {
                    color: 'secondary.main',
                },
            };
    }
}
